import { z } from "zod/v4";

export const contactFormSchema = z.object({
  custuname: z.string().min(1, "Please provide a Name"),
  custemail: z.email("Please provide a valid Email"),
  custorg: z.string().min(1, "Please provide an Organization"),
  phone1: z
    .string()
    .regex(
      /^$|^[+\d][\d\s().,-]{6,18}\d$/,
      "Please provide a valid Phone Number",
    )
    .optional(),
  cid: z.string().min(1, "Please select a Category"),
  req: z
    .string()
    .min(1, "Please provide a Remark, Comment, and/or Question")
    .max(2000, "Please limit to 2000 characters"),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
